import React from 'react'
import '../privacyTabs/PrivacyTab.css'
import { Link } from 'react-router-dom'

const PrivacyTab = () => {
  return (
    <div className="tabs-detail-sec setting-tab">
        <div className='privacy-center-sec'>
            <div className='head-top'>
              <h2>Privacy Center</h2>
              <p>Control your privacy. We’re here to protect you.</p>
            </div>
            <div className='add-data-sec'>
              <h3>Ads and Data</h3>
              <ul>
                <li className='d-flex align-items-center justify-content-between gap-2'>
                  <span>Data sharing and collection for ads</span>
                  <span>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.667319 6.66668L8.78065 6.66668L5.05398 10.3933L6.00065 11.3333L11.334 6.00001L6.00065 0.666677L5.06065 1.60668L8.78065 5.33334L0.667319 5.33334L0.667319 6.66668Z" fill="#301E39"/></svg>
                  </span>
                </li>
                <li className='d-flex align-items-center justify-content-between gap-2'>
                  <span>Third party apps access</span>
                  <span>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.667319 6.66668L8.78065 6.66668L5.05398 10.3933L6.00065 11.3333L11.334 6.00001L6.00065 0.666677L5.06065 1.60668L8.78065 5.33334L0.667319 5.33334L0.667319 6.66668Z" fill="#301E39"/></svg>
                  </span>
                </li>
                <li className='d-flex align-items-center justify-content-between gap-2'>
                  <span>Promotions data control personalised promos</span>
                  <span>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.667319 6.66668L8.78065 6.66668L5.05398 10.3933L6.00065 11.3333L11.334 6.00001L6.00065 0.666677L5.06065 1.60668L8.78065 5.33334L0.667319 5.33334L0.667319 6.66668Z" fill="#301E39"/></svg>
                  </span>
                </li>
              </ul>
            </div>
            <div className='privacy-btn d-flex align-items-center gap-3 flex-wrap'>
              <div className='left-btn'>
                <h6>Lust Story Privacy Policy</h6>
                <Link href="" className='btn btn-primary'>Read Privacy Policy</Link>
              </div>
              <div className='right-btn'>
                <h6>Account Security</h6>
                <Link href="" className='btn btn-second d-flex align-items-center gap-2 justify-content-center'> 
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.24935 15.8333C5.24935 16.75 5.99935 17.5 6.91602 17.5H13.5827C14.4993 17.5 15.2493 16.75 15.2493 15.8333V7.5C15.2493 6.58333 14.4993 5.83333 13.5827 5.83333H6.91602C5.99935 5.83333 5.24935 6.58333 5.24935 7.5V15.8333ZM7.74935 7.5H12.7493C13.2077 7.5 13.5827 7.875 13.5827 8.33333V15C13.5827 15.4583 13.2077 15.8333 12.7493 15.8333H7.74935C7.29102 15.8333 6.91602 15.4583 6.91602 15V8.33333C6.91602 7.875 7.29102 7.5 7.74935 7.5ZM13.166 3.33333L12.5743 2.74167C12.4243 2.59167 12.2077 2.5 11.991 2.5H8.50768C8.29102 2.5 8.07435 2.59167 7.92435 2.74167L7.33268 3.33333H5.24935C4.79102 3.33333 4.41602 3.70833 4.41602 4.16667C4.41602 4.625 4.79102 5 5.24935 5H15.2493C15.7077 5 16.0827 4.625 16.0827 4.16667C16.0827 3.70833 15.7077 3.33333 15.2493 3.33333H13.166Z" fill="#FE5F7C"/></svg>
                  Delete Account
                </Link>
              </div>
            </div>
        </div>
    </div>
  )
}

export default PrivacyTab
